import { styled, Link as MUILink, Box } from "@mui/material";
import { BodyTextM } from "./Typography";

export const Root = styled(MUILink, {
  shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled?: boolean }>(({ disabled, theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  background: "none",
  border: "none",
  cursor: disabled ? "default" : "pointer",
  font: "inherit",
  color: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
  pointerEvents: disabled ? "none" : "auto",
  fontWeight: theme.typography.fontWeightBold,
}));

export const TriggerText = styled(BodyTextM)(({ theme }) => ({
  display: "inline-block",
  verticalAlign: "middle",
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  marginLeft: theme.spacing(2),
  whiteSpace: "nowrap",
}));
